/**
 * File sensitivity values
 */
export enum FileSensitivityEnum {
	PUBLIC = 'public',
	INTERNAL = 'internal',
	PERSONAL_DATA = 'personal-data',
	CONFIDENTIAL = 'confidential',
}
